module.exports = __webpack_public_path__ + "img/lenovo-manual.8473063c.png";